import { z } from 'zod';
import { DeploymentTypeSchema, JurisdictionSchema, OrganisationTypeSchema, TagSchema, } from './organisation.js';
/**
 * Import/export of APPROVED, NON-SENSITIVE organisation master data only:
 * identity fields and tags. Contacts, notes, cases and anything with
 * personal or commercial detail are deliberately excluded from both
 * directions. Export requires an approved 'data.export' request.
 */
export const IMPORT_COLUMNS = [
    'legalName',
    'displayName',
    'organisationType',
    'deploymentType',
    'jurisdiction',
    'tags',
];
export const ImportRowSchema = z
    .object({
    legalName: z.string().trim().min(2).max(200),
    displayName: z.string().trim().min(2).max(200),
    organisationType: OrganisationTypeSchema,
    deploymentType: DeploymentTypeSchema,
    jurisdiction: JurisdictionSchema,
    tags: z.array(TagSchema).max(20),
})
    .strict();
export const ImportPreviewRowSchema = z.object({
    rowNumber: z.number().int(),
    action: z.enum(['create', 'skip_duplicate', 'error']),
    errors: z.array(z.string()),
    legalName: z.string().nullable(),
    displayName: z.string().nullable(),
});
export const ImportPreviewResponseSchema = z.object({
    token: z.string(),
    totalRows: z.number().int(),
    creatable: z.number().int(),
    duplicates: z.number().int(),
    errored: z.number().int(),
    rows: z.array(ImportPreviewRowSchema),
    expiresAt: z.iso.datetime(),
});
export const ImportCommitSchema = z
    .object({
    /** Preview token — commits exactly what was previewed, nothing else. */
    token: z.string().min(10),
})
    .strict();
export const MAX_IMPORT_ROWS = 500;
export const MAX_IMPORT_BYTES = 512 * 1024;
//# sourceMappingURL=importexport.js.map